/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {claimByPaymentToken} from '../api'

export const useMutationClaimByPaymentToken = createReactQueryMutationHook('claimByPaymentToken', claimByPaymentToken)
